import React from 'react';
import classNames from 'classnames';
import bowser from 'yola-bowser';
import TreeViewItemText from './components/tree-view-item-text';
import TreeViewItemIcon from './components/tree-view-item-icon';
import TreeViewItemActions from './components/tree-view-item-actions';
import { BaseTreeViewItemProps } from './types';
import connectWhen from '../../helpers/connect-when';
import { TYPES } from '../../../icon/constants';

const defaultActions = [];

const BaseTreeViewItem = ({
  title,
  iconGlyph,
  customIconGlyph = null,
  hoverIconGlyph = null,
  iconType = TYPES.default,
  selected = false,
  disabled = false,
  onClick = Function.prototype,
  description = null,
  actions = defaultActions,
  isEmpty = false,
  draggable = true,
  isDragging = false,
  highlighted = false,
  connectDragSource = Function.prototype,
}) => {
  const isMobile = bowser.mobile;
  const hasActions = !!actions?.length;
  const shouldRenderActions =
    ((hasActions && !disabled) || (hasActions && isMobile)) && !isDragging;

  const classes = classNames('ws-ui-tree-view-item', {
    'ws-ui-tree-view-item--disabled': disabled,
    'ws-ui-tree-view-item--selected': selected,
    'ws-ui-tree-view-item--mobile': isMobile,
    'ws-ui-tree-view-item--is-empty': isEmpty,
    'ws-ui-tree-view-item--is-dragging': isDragging,
    'ws-ui-tree-view-item--draggable': draggable,
    'ws-ui-tree-view-item--highlighted': highlighted,
  });

  return (
    <div className={classes} onClick={onClick}>
      {!isEmpty && (
        <React.Fragment>
          {connectWhen(
            draggable && !isEmpty,
            connectDragSource
          )(
            <div className="ws-ui-tree-view-item__content">
              <TreeViewItemIcon
                iconGlyph={iconGlyph}
                customIconGlyph={customIconGlyph}
                hoverIconGlyph={hoverIconGlyph || iconGlyph}
                iconType={iconType}
                disabled={disabled}
              />
              <TreeViewItemText title={title} description={description} />
            </div>
          )}
          {shouldRenderActions && <TreeViewItemActions actions={actions} disabled={disabled} />}
        </React.Fragment>
      )}
    </div>
  );
};

BaseTreeViewItem.propTypes = BaseTreeViewItemProps;

export default BaseTreeViewItem;
